<template>
  <v-row justify="center">
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('course') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="courseForm">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div v-if="course.id" class="course-info">
                    <div v-if="course.createdAt">
                      {{ $t('Created on') }}:
                      {{course.createdAt | formatLocaleDate}}
                    </div>
                    <div v-if="course.author">
                      {{ $t('Created from') }}:
                      {{course.author.firstName}} {{course.author.lastName}}
                    </div>
                    <div v-if="course.lastUpdatedBy">
                      {{ $t('Last modified from') }}:
                      {{course.lastUpdatedBy.firstName}} {{course.lastUpdatedBy.lastName}}
                    </div>
                    <div v-if="course.updatedAt">
                      {{ $t('Last modified on') }}:
                      {{course.updatedAt | formatLocaleDate}}
                    </div>https://kurse.c-learning.com/app/courses/?course=KURS-ID&chapter=KAPITEL-ID&lesson=LEKTION-ID&al=0
                    <div v-if="course.id">
                      ID: {{course.id}}
                    </div>
                    <div v-if="course.id">
                      Deeplink: https://kurse.c-learning.com/app/courses/?course={{ course.id }}&al=0
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      v-model="course.title"
                      label="Titel"
                      required
                      :rules="courseTitleRules()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                      v-model="course.tags"
                      :disabled="isUpdating"
                      :items="allTags"
                      filled
                      chips
                      label="Tags"
                      item-text="name"
                      item-value="id"
                      item-color="dark-grey"
                      multiple
                  >
                    <!--                      append-icon="mdi-plus"-->
                    <!--                      @click:append="addLabel"-->

                    <template v-slot:selection="data">
                      <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          :color="data.item.color"
                          text-color="white"
                          @click="data.select"
                          @click:close="removeTag(data.item)"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content class="ma-0">
                          <v-list-item-title>
                            <v-chip
                                v-html="data.item.name"
                                class="ma-0"
                                close
                                :color="data.item.color"
                                text-color="white"
                            />
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <tiptap-vuetify
                      v-model="course.description"
                      :extensions="extensions"
                  />
                </v-col>
                <v-col cols="12">
                  <image-input
                      v-model="course.image"
                      :label="$t('Title image')"
                  />
                </v-col>
                <v-col cols="12">
                  <date-picker :label="$t('Course start')" v-model="course.startDate"/>
                </v-col>
                <v-col cols="12">

                  <v-expansion-panels
                      v-model="chapterPanel"
                      multiple
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{ $t('Chapter') }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <draggable
                            :list="selectedChapters"
                            class="list-group"
                            ghost-class="ghost"
                            :move="checkMove"
                            @start="dragging = true"
                            @end="dragging = false"
                        >
                          <v-card
                              class="list-group-item"
                              v-for="element in selectedChapters"
                              :key="element.id"
                          >
                            <v-card-text>
                              <v-expansion-panels
                                  multiple
                                  flat
                              >
                                <v-expansion-panel>
                                  <v-expansion-panel-header>
                                    <v-row
                                    >
                                      {{ element.title }}
                                      <v-spacer/>
                                      <v-icon
                                          class="mr-5"
                                          color="secondary"
                                          small
                                          @click.stop="deleteItem(element)"
                                      >
                                        mdi-delete
                                      </v-icon>
                                    </v-row>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-row>
                                      <v-col cols="12">
                                        <span class="pb-4" v-html="element.description"/>
                                      </v-col>
                                      <v-col cols="12">
                                        <date-picker v-if="!course.startDate" :label="$t('Start date')" v-model="element.startDate"/>
                                        <template v-else>
                                          <v-text-field v-model.number="element.startOffsetDays" :label="$t('Accessible in days after course started')"/>
                                          {{ $t('Effective date') }}: {{element.startOffsetDays | effectiveDate(course.startDate)}}
                                        </template>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-text-field :label="$t('Alias title for course')" v-model="element.aliasTitle"/>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-btn color="primary" @click="dldialog = true">Deeplink</v-btn>

                                        <v-dialog v-model="dldialog" max-width="290">
                                          <v-card>
                                            <v-card-title class="headline">Deeplink</v-card-title>
                                            <v-card-text>
                                              https://kurse.c-learning.com/app/courses/?course={{ course.id }}&chapter={{ element.id }}&al=0
                                            </v-card-text>
                                            <v-card-actions>
                                              <v-spacer></v-spacer>
                                              <v-btn color="primary" text @click="dldialog = false">Schließen</v-btn>
                                            </v-card-actions>
                                          </v-card>
                                        </v-dialog>
                                      </v-col>
                                    </v-row>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-card-text>
                          </v-card>
                        </draggable>
                        <v-row class="mt-2">
                          <v-col>
                            <v-autocomplete
                                v-model="selectedChapter"
                                :items="chapters"
                                cache-items
                                dense
                                class="mx-4"
                                hide-no-data
                                hide-details
                                :label="$t('Chapter')"
                                item-text="title"
                                item-value="id"
                            ></v-autocomplete>
                          </v-col>
                          <v-col>
                            <v-btn
                                rounded
                                dense
                                color="primary"
                                :disabled="selectedChapter === null"
                                @click="addChapter"
                            >
                              Hinzufügen
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      v-model="course.edition"
                      :label="$t('Edition')"
                      required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select v-model="course.status" :items="states" :label="$t('State')"></v-select>
                </v-col>
                <v-col v-if="user.role !== 'user'" cols="12">
                  <user-select
                      :value.sync="course.managers"
                      :users="users"
                      :label="$t('Course manager')"
                      multiple
                      @removeItem="removeManager"
                  />
                </v-col>
                <v-col cols="12">

                  <v-expansion-panels
                      v-model="extensionPanel"
                      v-if="course.extensions"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{ $t('Extensions') }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="6" class="my-0 py-0">
                            <v-checkbox :label="$t('Files')" v-model="course.extensions.uploads"></v-checkbox>

                          </v-col>
                          <v-col cols="6" class="my-0 py-0">
                            <v-checkbox :label="$t('Events')" v-model="course.extensions.events"></v-checkbox>

                          </v-col>
                          <v-col cols="6" class="my-0 py-0">
                            <v-checkbox :label="$t('Chat')" v-model="course.extensions.chat"></v-checkbox>
                          </v-col>
                          <v-col cols="6" class="my-0 py-0">
                            <v-checkbox :label="$t('Certificates')" v-model="course.extensions.certificates"></v-checkbox>
                          </v-col>
                          <v-col cols="6" class="my-0 py-0">
                            <v-checkbox :label="$t('Badges')" v-model="course.extensions.badges"></v-checkbox>
                          </v-col>
                          <v-col cols="6" class="my-0 py-0">
                            <v-checkbox :label="$t('Show user list')" v-model="course.extensions.showFellowStudents"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
                <v-col cols="12">

                  <v-expansion-panels
                      v-if="course.extensions && course.extensions.uploads"
                      v-model="uploadPanel"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{ $t('Files') }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col class="text-right mb-6">
                            <v-btn
                                rounded
                                color="primary"
                                dark
                                @click="addUpload"
                            >
                              <v-icon left>mdi-plus</v-icon>
                              {{ $t('File') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-data-table
                            :headers="uploadHeaders"
                            :items="course.uploads"
                            :items-per-page="10"
                            class="elevation-1"
                            sort-by="originalName"
                            :sort-desc="true"
                        >
                          <template v-slot:item.tags="{ item }">
                            <v-chip
                                v-for="tag in uploadTags(item)"
                                :key="tag.id"
                                class="ma-1"
                                small
                                :color="tag.color"
                                text-color="white"
                            >
                              {{ tag.name }}
                            </v-chip>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <div class="text-no-wrap">
                              <v-icon
                                  small
                                  class="mr-2"
                                  @click="editUpload(item)"
                              >
                                mdi-pencil
                              </v-icon>
                              <v-icon
                                  small
                                  @click="deleteUpload(item)"
                              >
                                mdi-delete
                              </v-icon>
                            </div>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
                <v-col cols="12">

                  <v-expansion-panels
                      v-if="course.extensions && course.extensions.events"
                      v-model="eventPanel"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{ $t('Events') }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col class="text-right mb-6">
                            <v-btn
                                rounded
                                color="primary"
                                dark
                                @click="addEvent"
                            >
                              <v-icon left>mdi-plus</v-icon>
                              {{ $t('Event') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headers"
                            :items="course.events"
                            :items-per-page="10"
                            class="elevation-1"
                            sort-by="startDate"
                            :sort-desc="true"
                        >
                          <template v-slot:item.startDate="{ item }">
                            {{item.startDate | formatLocaleDateTime}}
                          </template>
                          <template v-slot:item.endDate="{ item }">
                            {{item.endDate | formatLocaleDateTime}}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <div class="text-no-wrap">
                              <v-icon
                                  small
                                  class="mr-2"
                                  @click="editEvent(item)"
                              >
                                mdi-pencil
                              </v-icon>
                              <v-icon
                                  small
                                  class="mr-2"
                                  @click="duplicateEvent(item)"
                              >
                                mdi-content-copy
                              </v-icon>
                              <v-icon
                                  small
                                  @click="deleteEvent(item)"
                              >
                                mdi-delete
                              </v-icon>
                            </div>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                      v-model="course.badges"
                      :items="badges"
                      filled
                      chips
                      :label="$t('Badges')"
                      item-text="name"
                      item-value="id"
                      multiple
                  >
                    <template v-slot:selection="data">
                      <v-chip
                          class="mt-2"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="removeBadge(data.item)"
                      >
                        <img class="badge-image badge-image badge-image-small" v-if="data.item.image" :src="getFileUrl(data.item.image.path)">
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content class="ma-0">
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="6">{{data.item.name}}</v-col>
                            <v-col cols="6"><img class="badge-image" v-if="data.item.image" :src="getFileUrl(data.item.image.path)"></v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  <v-btn @click="assignBadges">{{$t('Assign badges')}}</v-btn>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                      :no-resize="true"
                      rows="2"
                      v-model="course.comment"
                      :label="$t('Comment')"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="saveCourse"
          >
            {{ $t('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirmDialog"/>
    <course-event-dialog ref="courseEventDialog"/>
    <course-upload-dialog ref="courseUploadDialog" :all-tags="allTags"/>
    <course-upload-edit-dialog ref="courseUploadEditDialog" :all-tags="allTags"/>
    <course-badge-assign-dialog ref="courseBadgeAssignDialog"/>
    <snackbar ref="snackbar"></snackbar>
    <v-snackbar
        v-model="saveSuccess"
        color="success"
        multi-line="multi-line"
        timeout="2500"
    >
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-check-circle</v-icon>
        <v-layout column>
          <div>{{ $t('Course successfully saved') }}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import APIService from '@/services/APIService'
import ConfirmDialog from '@/components/ConfirmDialog'
import CourseEventDialog from '@/components/CourseEventDialog'
import Snackbar from "@/components/Snackbar";
import draggable from 'vuedraggable'
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
import DatePicker from "@/components/DatePicker";
import ImageInput from "@/components/ImageInput";
import CourseUploadDialog from "@/components/CourseUploadDialog";
import CourseUploadEditDialog from "@/components/CourseUploadEditDialog";
import UserSelect from "@/components/UserSelect";
import {getFileUrl} from "@/utils/common";
import CourseBadgeAssignDialog from "@/components/CourseBadgeAssignDialog";


const COURSE_INIT_DATA = {
  status: 'draft',
  chapters: [],
  extensions: {},
  events: [],
  uploads: [],
}
export default {
  name: 'CourseEditDialog',
  components: {
    UserSelect, ImageInput, DatePicker, CourseEventDialog, CourseUploadDialog, CourseUploadEditDialog, CourseBadgeAssignDialog, Snackbar, ConfirmDialog, draggable, TiptapVuetify },
  data() {
    return {
      badges: [],
      chip1: true,
      chip2: true,
      chip3: true,
      chip4: true,
      date: undefined,
      menu1: false,
      showDialog: false,
      dldialog: false,
      values: [],
      value: null,
      course: [],
      saveSuccess: false,
      isCourseTitleTaken: false,
      parentId: 0,
      snackbarSuccess: {
        text: this.$t('Course successfully saved'),
        icon: 'mdi-check-circle',
        color: 'success'
      },
      chapters: [],
      filteredChapters: [],
      states: [
        { text: this.$t('Draft'), value: 'draft'},
        { text: this.$t('Published'), value: 'published' },
      ],
      selectedChapter: null,
      selectedChapters: [],
      dragging: false,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ],
      chapterPanel: false,
      extensionPanel: false,
      uploadPanel: false,
      eventPanel: false,
      loading: false,

      autoUpdate: true,
      isUpdating: false,
      name: 'Midnight Crew',
      allTags: [],
      headers: [
        {
          text: this.$t('Title'),
          align: 'left',
          sortable: true,
          value: 'title',
        },
        { text: this.$t('Start'),
          value: 'startDate',
          width: 180,
          sortable: true,
        },
        { text: this.$t('End'),
          value: 'endDate',
          width: 180,
          sortable: true,
        },
        {
          text: this.$t('Actions'),
          value: 'actions',
          align: 'end',
          width: 120, // Feste Breite für die Icons
          sortable: false
        }
      ],
      uploadHeaders: [
        {
          text: this.$t('Filename'),
          align: 'left',
          sortable: true,
          value: 'file.originalName',
        },
        { text: this.$t('Description'),
          value: 'description',
          sortable: true,
        },
        {
          text: 'Tags',
          value: 'tags',
          sortable: false,
        },
        {
          text: this.$t('Actions'),
          value: 'actions',
          align: 'end'
        }
      ],
    }
  },
  methods: {
    getFileUrl,
    assignBadges() {
      console.log("Open Course assign dialog")
      this.$refs.courseBadgeAssignDialog.show(this.course, this.badges).then(() => {
        console.log("Dialog closed")
      })
    },
    async addEvent() {
      this.$refs.courseEventDialog.show().then((event) => {
        const id = this.course.events.length ? Math.max(...this.course.events.map(event => event.id)) + 1 : 1
        this.course.events.push({...event, id})
      })
    },
    async addUpload() {
      this.$refs.courseUploadDialog.show().then((upload) => {
        console.log("File uploaded", upload)
        const id = this.course.uploads.length ? Math.max(...this.course.uploads.map(upload => upload.id)) + 1 : 1
        this.course.uploads.push({...upload, tags: upload.tags || [], id})
      })
    },
    async editUpload(upload) {
      this.$refs.courseUploadEditDialog.show(upload).then((updatedUpload) => {
        upload.description = updatedUpload.description
        upload.tags = updatedUpload.tags
      })
    },
    async duplicateEvent(event) {
      // Wir erstellen eine tiefe Kopie des Events
      const copy = { 
        ...event, 
        id: undefined, // ID entfernen, damit es als neu erkannt wird
        title: this.$t('Copy') + ': ' + event.title 
      }
      
      this.$refs.courseEventDialog.show(copy).then((newEvent) => {
        if (newEvent) {
          const id = this.course.events.length ? Math.max(...this.course.events.map(e => e.id || 0)) + 1 : 1
          this.course.events.push({ ...newEvent, id })
        }
      })
    },
    async editEvent(event) {
      this.$refs.courseEventDialog.show(event).then((event) => {
        console.log("Event emitted", event)
        this.course.events = this.course.events.map(e => event.id === e.id ? event : e)
      })
    },
    async deleteEvent(event) {
      await this.$refs.confirmDialog.show({
        title: this.$t("Remove event"),
        text: this.$t("Do you want to remove this event?"),
        confirm: this.$t('remove')
      })
      this.course.events = this.course.events.filter(e => event.id !== e.id)
    },
    async deleteUpload(upload) {
      console.log("upload", upload)
      await this.$refs.confirmDialog.show({
        title: this.$t('Remove file'),
        text: this.$t('Do you want to remove the following file?')+ " <b>"+(upload.file ? upload.file.originalName : (upload.path || this.$t('Unknown file'))) + "</b>",
        confirm: this.$t('remove')
      })
      this.course.uploads = this.course.uploads.filter((u) => u !== upload && (upload.id === undefined || upload.id !== u.id))
    },
    async create () {
      this.course = { ...COURSE_INIT_DATA }
      await this.loadData()
      this.showDialog = true
    },
    async edit(course) {
      this.course = course
      this.course.events = this.course.events.map((event,index) => ({...event, id: index+1}))
      this.course.uploads = this.course.uploads.map((upload,index) => ({...upload, tags: upload.tags || [], id: index+1}))
      await this.loadData()
      this.selectedChapters = this.course?.chapters?.map(chapter => ({
        ...this.chapters.find(c => chapter.chapter === c.id),
        ...chapter,
        startOffsetDays: chapter.startOffsetDays ?? 0,
      }))
      this.showDialog = true
    },
    async loadData() {
      const [chapters, tags, badges] = await Promise.all([
        APIService.getChapters(),
        APIService.getTags(),
        APIService.getBadges(),
      ])
      this.chapters = chapters
      this.allTags = tags
      this.badges = badges
    },
    close() {
      this.course = { ...COURSE_INIT_DATA }
      this.selectedChapter = null
      this.selectedChapters = []
      this.chapterPanel = undefined
      this.$refs.courseForm.resetValidation()
      this.chapters = []
      this.allTags = []
      this.eventPanel = false
      this.uploadPanel = false
      this.extensionPanel = false
      this.showDialog = false
    },
    async saveCourse() {
      if (!this.$refs.courseForm.validate()) {
        return
      }

      const courseToSave = {
        ...this.course,
        chapters: this.selectedChapters.map((chapter) => ({
          chapter: chapter.id,
          startOffsetDays: chapter.startOffsetDays,
          ...chapter.startDate ? {startDate: chapter.startDate} : {},
          ...chapter.aliasTitle ?  {aliasTitle: chapter.aliasTitle} : {},
        })),
        uploads: this.course.uploads
          .filter(upload => upload.file)
          .map((upload) => ({
            ...upload.file.id ? {file: upload.file.id} : {},
            path: upload.file.path,
            description: upload.description,
            tags: this.uploadTagIds(upload),
            uploadedBy: this.user.id,
          }))
      }

      await APIService.saveCourse(courseToSave)
      this.$refs.snackbar.show(this.snackbarSuccess)
      this.$emit('updated')
      this.close()
    },
    requiredRule (fieldName) {
      return [value => !!value || `${fieldName} `+this.$t('mandatory')]
    },
    courseTitleRules() {
      return [
        value => !!value || this.$t('Course title mandatory'),
        !this.isCourseTitleTaken || this.$t('Course title already taken')
      ]
    },
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    deleteItem(chapter) {
      console.log("Delete item", chapter)
      this.selectedChapters = this.selectedChapters.filter((_chapter) => chapter.id !== _chapter.id)
    },
    addChapter() {
      if(this.selectedChapters.find((chapter) =>  chapter.id === this.selectedChapter)) {
        console.log("Already added")
        return
      }
      this.selectedChapters.push({...this.chapters.find((chapter) => chapter.id === this.selectedChapter)})
      this.selectedChapter = null
    },
    removeBadge(item) {
      const index = this.course.badges.indexOf(item.id)
      if (index >= 0) this.course.badges.splice(index, 1)
    },
    removeTag (item) {
      const index = this.course.tags.indexOf(item.id)
      if (index >= 0) this.course.tags.splice(index, 1)
    },
    uploadTags(upload) {
      return (upload.tags || [])
        .map(uploadTag => {
          const tagId = typeof uploadTag === 'object' ? uploadTag.id : uploadTag
          return this.allTags.find(tag => String(tag.id) === String(tagId)) || (typeof uploadTag === 'object' ? uploadTag : undefined)
        })
        .filter(tag => tag !== undefined)
    },
    uploadTagIds(upload) {
      return (upload.tags || [])
        .map(tag => typeof tag === 'object' ? tag.id : tag)
        .filter(tag => tag !== undefined && tag !== null)
        .map(tag => String(tag))
    },
    removeManager(item) {
      const index = this.course.managers.indexOf(item.id)
      if (index >= 0) this.course.managers.splice(index, 1)
    },
  },
  computed: {
    ...mapState(['user', 'users']),
  },
  watch: {
    "course.name"() {
      this.isCourseTitleTaken = false
    },
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.badge-image {
  max-width: 100px;
  padding: 4px;
}
</style>
